import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useKeycloak } from 'src/components/AuthHOC';

export const useLogError = (error: Error) => {
  const { currentUser } = useKeycloak();

  // Using an effect instead of a function, for cleaner use
  // of the whole `useLogError` hook
  useEffect(() => {
    Sentry.captureException(error);
  }, [error, currentUser]);
};
